import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { useCommon } from 'src/domains/common/Common';
import { Messages } from 'src/domains/layouts/webview/components/Messages/Messages';
import { BasicDataModel } from 'src/domains/players/state/BasicDataModel';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { ContactPreferencesToggleList } from 'src/domains/players/webview/components/Account/preferencesTab/contactPreferencesToggleList/ContactPreferencesToggleList';
import { ContactPreferencesState } from 'src/domains/players/webview/components/Account/preferencesTab/contactPreferences/ContactPreferences.state';
import { ContactPreferencesNewStateInfoMessageType } from 'src/domains/players/webview/components/Account/preferencesTab/contactPreferencesNew/ContactPreferencesNew.state';

const renderMessage = (infoMessage: ContactPreferencesNewStateInfoMessageType): JSX.Element | string => {
    if (infoMessage === 'error') {
        return (
            <Messages
                type='error'
                marginTop='8px'
                message={
                    <I18n
                        langKey='account.contact-preferences.error-message'
                        defaultText='Sorry, we seem to have a problem. Please try again.'
                    />
                }
            />
        );
    } else if (infoMessage === 'success') {
        return (
            <Messages
                type='success'
                marginTop='8px'
                message={
                    <I18n
                        langKey='account.contact-preferences.success-message'
                        defaultText='Contact preferences have been successfully changed.'
                    />
                }
            />
        );
    }

    return '';
};

export const ContactPreferences = observer('ContactPreferences', () => {
    const common = useCommon();
    const basicData = BasicDataModel.get(common);
    const [contactPreferences] = useState(() => new ContactPreferencesState(common));
    const config = ConfigComponents.get(common);
    const { contactPreferencesCategories } = config.config;

    const data = basicData.basicDataReady;
    const id = data?.id ?? null;
    const email = data?.contactPreferencesByCategory?.find((item) => item.type === 'email');
    const phone = data?.contactPreferencesByCategory?.find((item) => item.type === 'phone');
    const sms = data?.contactPreferencesByCategory?.find((item) => item.type === 'sms');

    const state = contactPreferences.contactPreferencesToggleListStateAuto.get([
        email?.categories ?? [],
        phone?.categories ?? [],
        sms?.categories ?? [],
    ]);

    return (
        <div>
            <ContactPreferencesToggleList
                state={state}
                contactPreferencesCategories={contactPreferencesCategories}
                variant='light'
                onToggle={(): Promise<void> => contactPreferences.submitContactPreferences(id, state)}
            />
            {renderMessage(contactPreferences.infoMessage)}
        </div>
    );
});
